import { createFileRoute } from '@tanstack/react-router'
import { internshipDetailsSearchSchema } from '@/features/internships/view-internship/model/internshipDetailsSearch'
import { InternshipDetailsPage } from '@/pages/internships/ui/InternshipDetailsPage'
export const Route = createFileRoute('/internships_/$internshipId')({
  validateSearch: internshipDetailsSearchSchema,
  component: Details,
})
function Details() {
  const { internshipId } = Route.useParams()
  return <InternshipDetailsPage internshipId={internshipId} />
}
